import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const carouselBlocks = document.querySelectorAll('.columns-carousel-block');

  if (0 < carouselBlocks.length) {
    carouselBlocks.forEach((carouselBlock) => {
      new Swiper(carouselBlock.querySelector('.columns-carousel'), {
        slidesPerView: 1,
        spaceBetween: 20,
        centerInsufficientSlides: true,
        wrapperClass: 'acf-innerblocks-container',
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1080: {
            slidesPerView: 3,
            spaceBetween: 80,
          },
        },
        navigation: {
          nextEl: carouselBlock.querySelector(
            '.columns-carousel__navigation .swiper-button-next'
          ),
          prevEl: carouselBlock.querySelector(
            '.columns-carousel__navigation .swiper-button-prev'
          ),
        },
        pagination: {
          el: carouselBlock.querySelector(
            '.columns-carousel__navigation .swiper-pagination'
          ),
          clickable: true,
        },
      });
    });
  }
});
